/* eslint-disable */
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
// If you need to update this file, make changes in the Core application
// then run `import:api` in your terminal from the root of this project.
import { AxiosPromise } from 'axios';

import { baseClientConstructorProps } from 'app/api/apiClient/config';

import { BaseClient, BaseClientConstructorProps, QueryParams, SendRequestPayload } from '../baseClient';
import { 
  CoreUsersListUsersParams,
  CreateUserRequest,
  UpdateUserRequest,
  UpdateMfaTypeRequest,
  UnlockUserRequest,
  SendUserCodeRequest,
  VerifyUserCodeRequest,
  UsersResponse,
  UserResponse,
  SuccessResponse,
  ListUserRolesResponse,
  ListUserNotificationsResponse,
  VerifyUserCodeResponse,
  UserNotificationResponse,
  OktaLoginTypeResponse
 } from '../types';

  //  CoreUsersClient
class CoreUsersClient extends BaseClient {
    constructor(props: BaseClientConstructorProps) {
        super(props);
    }

    readonly listUsers = (queryParams: CoreUsersListUsersParams): AxiosPromise<UsersResponse> => {
        let url_ = "/api/v1/core/users";

        const qParams = { ...queryParams };
        const hasExportReport = "exportReport" in qParams && qParams.exportReport;
        if (hasExportReport) {
            if ("page" in qParams) {
                delete qParams.page;
            }
            if ("pageSize" in qParams) {
                delete qParams.pageSize;
            }
        }

        const sendRequestPayload: SendRequestPayload = {
            responseType: hasExportReport ? "blob" : undefined,
            queryParams: qParams as unknown as QueryParams,
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly createUser = (payload: CreateUserRequest): AxiosPromise<UserResponse> => {
        let url_ = "/api/v1/core/users";

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "POST",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly getUser = (id: string): AxiosPromise<UserResponse> => {
        let url_ = "/api/v1/core/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));

        const sendRequestPayload: SendRequestPayload = {
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly deleteUser = (id: string): AxiosPromise<SuccessResponse> => {
        let url_ = "/api/v1/core/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));

        const sendRequestPayload: SendRequestPayload = {
            method: "DELETE",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly updateUser = (id: string, payload: UpdateUserRequest): AxiosPromise<UserResponse> => {
        let url_ = "/api/v1/core/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "PUT",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly listUserRoles = (): AxiosPromise<ListUserRolesResponse> => {
        let url_ = "/api/v1/core/users/roles";

        const sendRequestPayload: SendRequestPayload = {
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly listUserNotifications = (): AxiosPromise<ListUserNotificationsResponse> => {
        let url_ = "/api/v1/core/users/notifications";

        const sendRequestPayload: SendRequestPayload = {
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly sendMfa = (type: number): AxiosPromise<SuccessResponse> => {
        let url_ = "/api/v1/core/users/send_mfa/{type}";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));

        const sendRequestPayload: SendRequestPayload = {
            method: "PUT",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly updateMfaType = (type: number, payload: UpdateMfaTypeRequest): AxiosPromise<SuccessResponse> => {
        let url_ = "/api/v1/core/users/register_mfa/{type}";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "PUT",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly sendLoginRequest = (id: string): AxiosPromise<SuccessResponse> => {
        let url_ = "/api/v1/core/users/{id}/send_login_request";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));

        const sendRequestPayload: SendRequestPayload = {
            method: "PUT",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly unlockUser = (payload: UnlockUserRequest): AxiosPromise<SuccessResponse> => {
        let url_ = "/api/v1/core/users/unlock_user";

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "PUT",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly sendUserCode = (payload: SendUserCodeRequest): AxiosPromise<SuccessResponse> => {
        let url_ = "/api/v1/core/users/send_user_code";

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "POST",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly verifyUserCode = (payload: VerifyUserCodeRequest): AxiosPromise<VerifyUserCodeResponse> => {
        let url_ = "/api/v1/core/users/verify_user_code";

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "POST",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly getUserNotificatitons = (id: string): AxiosPromise<UserNotificationResponse[]> => {
        let url_ = "/api/v1/core/users/{id}/notifications";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));

        const sendRequestPayload: SendRequestPayload = {
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly oktaInfo = (): AxiosPromise<OktaLoginTypeResponse> => {
        let url_ = "/api/v1/core/users/okta_info";

        const sendRequestPayload: SendRequestPayload = {
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }
}
// CoreUsersClient
  
export const coreUsersClient = new CoreUsersClient(baseClientConstructorProps);
